import React, { createContext, useState } from "react";

// Create context for Users data
export const UsersContextApi = createContext();

const UsersContext = ({ children }) => {
  // User global state
  const [userData, setUserData] = useState({});
  const [clientUserData, setClientUserData] = useState({});
  const [offset, setOffset] = useState(0);
  const [allOffset, setAllOffset] = useState([0]);
  const [clientAllOffset, setClientAllOffset] = useState([0]);
  const [userListCount, setUserListCount] = useState(0);
  const [clientUserCount, setClientUserCount] = useState(0);
  const [deletedClientCount, setDeletedClientCount] = useState(0);
  const [currentClient, setCurrentClient] = useState(0);

  // Set user data into user State(userData)
  const updateUsersState = (newData, page) => {
    setUserData({ ...userData, [page]: newData });
  };

  // Set client Asset data into Asset State(clientAssetData)
  const updateClientAssetData = (newData, page) => {
    let tempData = clientUserData;
    if(page === 1) {
      tempData = {};
      setOffset(0);
      // setClientAllOffset([0]);
    }
    setClientUserData({ ...tempData, [page]: newData });
  };

  // Set offset into offSet State(offset)
  const updateUsersOffset = (newOffset) => {
    setOffset(newOffset);
  };

  // Set offset into offSet State(offset)
  const resetUserState = () => {
    setUserData({});
    setAllOffset([0]);
    setUserListCount(0);
  };

  const setAllOffsetState = (newOffset) => {
    setAllOffset((prevState) => [...prevState, newOffset]);
  };

  const setClientAllOffsetState = (newOffset) => {
    setClientAllOffset((prevState) => [...prevState, newOffset]);
  };

  // Set user list count into client State(clientCount)
  const updateUserListCount = (data) => {
    setUserListCount(data);
  };

  // Edit user and update user list
  const editUserList = (editedUser) => {
    const newUserData = userData.map((userInfo) => {
      if (userInfo.id === editedUser.id) {
        return editedUser;
      }
      return userInfo;
    });
    setUserData(newUserData);
  };

  // Set current user data after delete functionality
  const deleteUserData = (newUserData) => {
    setUserData(newUserData);
  };

  // Set current client id
  const updateCurrentClientId = (newAssetData) => {
    setCurrentClient(newAssetData);
  };

  // Set client Asset list count into clientAsset State(clientAssetCount)
  const clientUserListCount = (data) => {
    setClientUserCount(data);
  };

  // Set empty user list
  const updateUsersStateAsEmpty = () => {
    setUserData([]);
    setClientUserData({});
  };

  const resetClientuserState = () => {
    setClientAllOffset([0]);
    setClientUserData({});
    setClientUserCount(0);
  };

  return (
    <UsersContextApi.Provider
      value={{
        userData,
        clientUserData,
        offset,
        clientAllOffset,
        userListCount,
        clientUserCount,
        deletedClientCount,
        allOffset,
        currentClient,
        updateUsersState,
        updateUsersOffset,
        editUserList,
        clientUserListCount,
        setClientUserData,
        updateUserListCount,
        updateCurrentClientId,
        updateUsersStateAsEmpty,
        deleteUserData,
        setDeletedClientCount,
        setAllOffsetState,
        setClientAllOffsetState,
        resetUserState,
        updateClientAssetData,
        resetClientuserState,
      }}
    >
      {children}
    </UsersContextApi.Provider>
  );
};

export default UsersContext;
